



































import { Component, Prop, Watch, Vue } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import { forEach, isArrayLike } from 'lodash'

import { DEFAULT_LOCALE } from '@/i18n'

import Widget from '@/components/Widget.vue'
import EventManager from '@/components/event-manager'


@Component({
  components: {
    Widget,
    EventManager,
  },
  beforeRouteLeave: (to, from, next) => {
    window.confirm('Are you sure you want to leave? Any unsaved data will be lost.')
      ? next()
      : next(false)
  }
})
export default class FormView extends Vue {
  @Getter('form/locales')
  locales!: string[]

  iconElements?: NodeListOf<HTMLLinkElement>
  faviconElement?: HTMLLinkElement
  active: boolean = true
  show: boolean = false
  loading: boolean = true
  error: boolean = true

  get rootWidget () {
    return this.$store.getters['form/activeWidget']
  }

  get favicon () {
    return this.$store.getters['form/favicon']
  }

  async mounted () {
    this.loading = true
    this.error = false
    try {
      await this.$store.dispatch('form/loadForm')
      if (!this.locales.includes(this.$i18n.locale)) {
        const locale = this.locales[0] || DEFAULT_LOCALE
        this.$router.replace({
          ...this.$route,
          params: {
            ...this.$route.params,
            locale
          }
        })
      }
    } catch {
      this.error = true
    } finally {
      this.loading = false
    }
  }

  beforeDestroy () {
    this.active = false
    this.faviconChanged(null)
  }

  @Watch('rootWidget', { immediate: true })
  rootChanged () {
    // Trick to prevrend render errors
    this.show = false
    Vue.nextTick(() => this.show = true)
  }

  @Watch('favicon', { immediate: true })
  faviconChanged (newValue: any) {
    // Remove existing icon
    this.removeHeadElements(this.faviconElement)
    this.faviconElement = undefined
    if (newValue) {
      // Find existing icon elements
      this.iconElements = document.head.querySelectorAll('link[rel=icon]')
      // Remove the existing icon elements
      this.removeHeadElements(this.iconElements)
      // Add the new icon element
      this.faviconElement = this.createFaviconElement(newValue)
      this.appendHeadElements([this.faviconElement])
    } else {
      this.appendHeadElements(this.iconElements)
      this.iconElements = undefined
    }
  }

  appendHeadElements (elements?: Element | ArrayLike<Element>) {
    if (elements) {
      if (!isArrayLike(elements)) {
        elements = [elements]
      }
      forEach(elements, e => document.head.appendChild(e))
    }
  }

  removeHeadElements (elements?: Element | ArrayLike<Element>) {
    if (elements) {
      if (!isArrayLike(elements)) {
        elements = [elements]
      }
      forEach(elements, e => document.head.removeChild(e))
    }
  }

  createFaviconElement (src: string) {
    const link = document.createElement('link')
    link.rel = 'shortcut icon'
    link.href = src
    return link
  }
}
